import { get } from 'lodash';
import { ITicket } from './ITicket';

export class IncidentTicket implements ITicket {
  public id: string;
  public details: string;
  public main: string;
  public guid: string;
  public contact: string;
  public creationTime: string;
  public company: string;
  public status: string;
  public stateFinal: string;
  public stateId: string;
  public name: string;
  public description: string;
  public impact: string;
  public urgency: string;
  public priority: string;
  public outageStartDate: Date;
  public outageEndDate: Date;
  public occurrenceTime: Date;
  public solution: string;
  public closureCode: string;
  public category: string;
  public area: string;
  public subArea: string;
  public service: string;
  public ci: string;
  public department: string;
  public location: string;
  public source: string;
  public foreignTicketId: string;
  public topicType: string;
  public relations: any;

  constructor(
     ticket: { [key: string]: any },
     statuses: { [key: string]: any },
     prioritys: { [key: string]: any }
  ) {
    const relatedAddressbook = (ticket.relations || []).find(
      (relation: any) => relation.type === 'CUSTOMER' && relation.related_id === ticket.addressbook
    );

    this.id = ticket.id;
    this.guid = ticket.guid;
    this.topicType = ticket.topic_type;
    this.contact = relatedAddressbook ? relatedAddressbook.related_record.n_fn : '';
    this.creationTime = ticket.creation_time;
    this.company = get(ticket, 'company.org_name', null);
    this.status = get(ticket, 'state.name', null);
    this.name = ticket.name;
    this.description = ticket.description;
    this.impact = get(ticket, 'impact.name', null);
    this.urgency = get(ticket, 'urgency.name', null);
    this.location = get(ticket, 'location.name', null);
    this.department = get(ticket, 'department.name', null);
    this.priority = prioritys[ticket.priority];
    this.service = get(ticket, 'service.name', null);
    this.ci = ticket.ci && ticket.ci.name;
    this.source = ticket.source;
    this.stateFinal = get(ticket, 'state.final', null);
    this.stateId = get(ticket, 'state.id', null);
    this.relations = ticket.relations;
    if (ticket.customfields) {
      const { customfields: customFields } = ticket;
      const customFieldsValuesMap = statuses[ticket.state.id];
      this.outageStartDate = customFields.OutageStartTime || '';
      this.outageEndDate = customFields.OutageEndTime || '';
      this.occurrenceTime = customFields.OccurenceTime || '';
      this.solution = customFields.Solution;
      this.closureCode =
        customFieldsValuesMap && customFieldsValuesMap.ClosureCode && ticket.customfields &&
        customFieldsValuesMap.ClosureCode[ticket.customfields.ClosureCode],
      this.category =
        customFieldsValuesMap && customFieldsValuesMap.IncidentCategory && ticket.customfields &&
        customFieldsValuesMap.IncidentCategory[customFields.IncidentCategory];
      this.area =
        customFieldsValuesMap && customFieldsValuesMap.IncidentArea && ticket.customfields &&
        customFieldsValuesMap.IncidentArea[customFields.IncidentArea];
      this.subArea =
        customFieldsValuesMap && customFieldsValuesMap.IncidentSubarea && ticket.customfields &&
        customFieldsValuesMap.IncidentSubarea[customFields.IncidentSubarea];
      this.foreignTicketId = customFields.ForeignTicketID;
    }
  }
}
